// Login.jsx
import { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import styles from "./styles.module.css";
import { auth, signInWithPopup, GoogleAuthProvider } from "../firebase";

const Login = ({ setToken }) => {


  
  
  const [data, setData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();
  
  useEffect(() => {
    const user = localStorage.getItem("token");
    if (user && user !== 'undefined') {
      navigate('/'); // Redirect to contents page if user is logged in
    }
  }, [navigate]);


  const handleChange = ({ target }) => {
    setData({ ...data, [target.name]: target.value });
  };

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      handleSocialSignin(result.user);
    } catch (error) {
      setError(error.message);
    }
  };

  const handleSocialSignin = async (user) => {
    const userData = {
      email: user.email,
      provider: user.providerId,
    };
    try {
      const url = `https://rescombackend.onrender.com/api/auth`;
      const { data: res } = await axios.post(url, userData);
      localStorage.setItem("token", res.data);
      setToken(res.data);
      // console.log(userData.email)
      const fetchedData = await fetchUserData(userData.email); // Replace with your function to fetch user data from MongoDB
      const encodedEmail = btoa(fetchedData.data.email);
      const queryParams = new URLSearchParams({
        p4rM5: encodedEmail,
      });
      const newUrl = `/?${queryParams.toString()}`;

      // Navigate to the new URL
      navigate(newUrl);
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status <= 500
      ) {
        console.log(error);
        setError(error.response.data.message);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = `https://rescombackend.onrender.com/api/auth`;
      console.log(url)
      const { data: res } = await axios.post(url, data);
      localStorage.setItem("token", res.data);
      setToken(res.data);
      const fetchedData = await fetchUserData(data.email); // Replace with your function to fetch user data from MongoDB
      const encodedEmail = btoa(fetchedData.data.email);
      const queryParams = new URLSearchParams({
        p4rM5: encodedEmail,
      });
      const newUrl = `/?${queryParams.toString()}`;

      // Navigate to the new URL
      navigate(newUrl);
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status <= 500
      ) {
        setError(error.response.data.message);
      }
    }
  };

  const fetchUserData = async (email) => {
    try {
      const url = `https://rescombackend.onrender.com/api/auth/${email}`;
      const { data } = await axios.get(url);
      // console.log("Fetched user data:", data);
      return data; // User data retrieved from MongoDB
    } catch (error) {
      console.error("Error fetching user data:", error);
      throw new Error("Failed to fetch user data");
    }
  };

  return (
    <div className={`${styles.login_container} page-transition`}>
      <div className={styles.login_form_container}>
        {/* Left section */}
        <div className={styles.left}>
          <form className={styles.form_container} onSubmit={handleSubmit}>
            <h1>Login to Your Account</h1>
            <input
              type="email"
              placeholder="Email"
              name="email"
              onChange={handleChange}
              value={data.email}
              required
              className={styles.input}
            />
            <input
              type="password"
              placeholder="Password"
              name="password"
              onChange={handleChange}
              value={data.password}
              required
              className={styles.input}
            />
            {error && <div className={styles.error_msg}>{error}</div>}
            <button type="submit" className={styles.green_btn}>
              Sign In
            </button>
          </form>

          {/* Social sign-in buttons */}
          <button onClick={handleGoogleSignIn} className="gsi-material-button">
            <div className="gsi-material-button-state"></div>
            <div className="gsi-material-button-content-wrapper">
              <div className="gsi-material-button-icon">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 48 48"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  style={{ display: "block" }}
                >
                  <path
                    fill="#EA4335"
                    d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
                  ></path>
                  <path
                    fill="#4285F4"
                    d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
                  ></path>
                  <path
                    fill="#FBBC05"
                    d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
                  ></path>
                  <path
                    fill="#34A853"
                    d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
                  ></path>
                  <path fill="none" d="M0 0h48v48H0z"></path>
                </svg>
              </div>
              <span className="gsi-material-button-contents">
                Sign in with Google
              </span>
              <span style={{ display: "none" }}>Sign in with Google</span>
            </div>
          </button>
        </div>

        {/* Right section */}
        <div className={styles.right}>
          <h1>New Here ?</h1>
          <Link
            to="/signup"
            onClick={() => {
              navigate("/signup");
              // window.location.reload();
            }}
          >
            <button type="button" className={styles.white_btn}>
              Sign Up
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
